import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { rawColors } from "../../../design-system/tokens/colors";
import { controlSize } from "../../../design-system/tokens/controlSizes";
import { duration, easing } from "../../../design-system/tokens/transitions";

export const ToolbarRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[3]};
  width: 100%;
`;

export const Title = styled.h2`
  margin: 0;
  flex: 1 0 0;
  min-width: 0;
  ${typographyMixin("heading", "h2")}
  color: ${rawColors.text.highEmphasis};
`;

/**
 * Toolbar search field — height is content-derived (caption-3 line-height
 * 18px + 8px padding-y × 2 + 1px border × 2 = 36px), so no hardcoded height
 * needed. Width comes through a prop so consumers can use any CSS length.
 */
export const SearchField = styled.div<{
  $width: string;
  $controlHeight?: string;
}>`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  flex-shrink: 0;
  width: ${({ $width }) => $width};
  height: ${({ $controlHeight }) => $controlHeight ?? controlSize.field.lg};
  box-sizing: border-box;
  padding: 0 ${spacing[5]};
  background-color: ${rawColors.structural.white};
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: 8px;
  transition: border-color ${duration.fast} ${easing.smooth};

  &:focus-within {
    border-color: ${rawColors.primary[500]};
  }
`;

export const SearchIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${rawColors.text.lowEmphasis};
`;

export const SearchInputEl = styled.input`
  flex: 1 0 0;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  padding: 0;
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.highEmphasis};

  &::placeholder {
   ${typographyMixin("caption", 4)}
    color: ${rawColors.text.lowEmphasis};
    font-weight: 400;
  }
`;
